/* src/app/components/admin/accounts/manage-user-access-dialog/manage-user-access-dialog.component.scss */
.mat-mdc-dialog-content {
  padding: 12px 24px 12px 24px;
  min-width: 200px;
  min-height: 50px;
  display: flex;
  flex-direction: column;
}
.mat-mdc-dialog-title {
  padding: 24px 24px 24px 20px;
  margin: -24px -24px 10px -24px;
  background-color: rgb(48, 63, 159);
  color: white;
}
.row {
  padding-bottom: 15px;
}
.title {
  font-size: 10px;
  color: rgba(0, 0, 0, 0.54);
}
.list {
  height: 200px;
  overflow: auto;
  border: 1px solid #949494;
  border-radius: 4px;
}
/*# sourceMappingURL=manage-user-access-dialog.component.css.map */
